import { render, staticRenderFns } from "./healthData.vue?vue&type=template&id=40e3002e&scoped=true&"
import script from "./healthData.vue?vue&type=script&lang=js&"
export * from "./healthData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e3002e",
  null
  
)

export default component.exports